import gql from 'graphql-tag';
import { QueryResult } from '../shared/object/queryResult.model';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
export class VendedorService {
    constructor(gqlclient) {
        this.gqlclient = gqlclient;
    }
    obtenerSegunId(rut_empresa, sucursal_codigo, codigo, callback) {
        const inputParams = {
            entidad: {
                rut_empresa,
                sucursal_codigo,
                codigo,
            },
        };
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType) {
            vendedor {
              obtenerSegunId(entidad: $entidad) {
                respuesta {
                  codigo
                  sucursal_codigo
                  rut_empresa
                  territorio_codigo
                  nombre
                  comision
                  fono1
                  fono2
                  estado
                  territorio_codigo
                  rut
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerSegunId;
            callback({ mensajes, respuesta });
        });
    }
    obtenerTodosParaReporte(rutEmpresa, sucursalCodigo, callback) {
        const inputParams = {
            rutEmpresa,
            sucursalCodigo,
        };
        this.gqlclient.query({
            query: gql `
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 0 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    rut
                    estado
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerActivos(rutEmpresa, sucursalCodigo, callback) {
        const inputParams = {
            rutEmpresa,
            sucursalCodigo,
        };
        this.gqlclient.query({
            query: gql `
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1 } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    rut
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerVendedores(rutEmpresa, sucursalCodigo, listaRubro, totalRubro, callback) {
        const inputParams = {
            rutEmpresa,
            sucursalCodigo,
            listaRubro,
            totalRubro,
        };
        this.gqlclient.query({
            query: gql `
          query ($rutEmpresa: Decimal, $sucursalCodigo: Decimal, $listaRubro: [Decimal], $totalRubro: Decimal) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: { rut_empresa: $rutEmpresa, sucursal_codigo: $sucursalCodigo, tipobusqueda: 1, listaRubro: $listaRubro, totalRubro: $totalRubro } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  registros {
                    codigo
                    rut_empresa
                    sucursal_codigo
                    nombre
                    rut
                    listaRubro
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
            callback({ mensajes, respuesta });
        });
    }
    obtenerActivosSegunFecha(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sucursal_codigo: Decimal, $fecha_desde: Date, $fecha_hasta: Date) {
            pedido {
              obtenerPedidosSegunVendedor(filtro: { exacto: { empresa_rut: $empresa_rut, sucursal_codigo: $sucursal_codigo, fecha_desde: $fecha_desde, fecha_hasta: $fecha_hasta } }) {
                mensajes {
                  codigo
                  contexto
                  texto
                  __typename
                }
                respuesta {
                  registros {
                    cantidad
                    vendedor_codigo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.pedido.obtenerPedidosSegunVendedor;
            callback({ mensajes, respuesta });
        });
    }
    obtenerVendedoresConfirmacionNventa(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($rutEmpresa: Decimal, $sucursalEmpresa: Decimal, $paginaActual: Int, $cantidadRegistrosPorPagina: Int, $soloAprobadosAnalisis: Boolean) {
            vendedor {
              obtenerVendedorSegunConfirmacionNotaVenta(
                rutEmpresa: $rutEmpresa
                sucursalEmpresa: $sucursalEmpresa
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
                soloAprobadosAnalisis: $soloAprobadosAnalisis
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                  __typename
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    nombre
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerVendedorSegunConfirmacionNotaVenta;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltro(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerSegunFiltro(filtro: { exacto: $entidad }, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    sucursal_codigo
                    rut_empresa
                    territorio_codigo
                    nombre
                    comision
                    fono1
                    fono2
                    estado
                    territorio_codigo
                    rut
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerSegunFiltro;
            if (!respuesta) {
                callback(new QueryResult(null, 0, 0, 0));
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
        });
    }
    obtenerReporteVentasVendedoresResumen(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    territorio_codigo
                    territorioNombre
                    monto_neto
                    descuento
                    neto_total
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresResumenExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresResumen(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresResumen;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresDetalle(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    nombrecomuna
                    codigo
                    nombre
                    monto_neto
                    descuento
                    neto_total
                    bruto_total
                    ruta_codigo
                    ruta_nombre
                    codsuclegacy
                    recorrido_codigo
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresDetalleExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresDetalle(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresDetalle;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresClientes(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClientes(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    nombrecomuna
                    nombreprovincia
                    territorio_codigo
                    territorioNombre
                    ipt_venta
                    total_maquina
                    monto_neto
                    descuento
                    neto_total
                    fecha_ingreso_cliente
                    monto_ultima_venta
                    dia_sin_venta
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClientes;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresClientesExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClientes(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClientes;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresClienteProductos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClienteProductosAsync(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    formato_codigo
                    formato_nombre
                    rubro_nombre
                    familia_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    codigo
                    nombre
                    fecha_ult_venta
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                    listaUnidadesxDocumento {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      dia_emision
                      formato_codigo
                      cantidad
                      producto_codigo
                      precio_neto
                      precio_unitario
                      monto_total_neto
                      monto_total
                      sku
                      monto
                      vendedor_codigo
                    }
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClienteProductosAsync;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresClienteProductosExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresClienteProductos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresClienteProductos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresProductos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresProductos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    formato_codigo
                    formato_nombre
                    rubro_nombre
                    familia_codigo
                    familia_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    codigo
                    nombre
                    fecha_ult_venta
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                    listaUnidadesxDocumento {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      dia_emision
                      formato_codigo
                      cantidad
                      producto_codigo
                      precio_neto
                      precio_unitario
                      monto_total_neto
                      monto_total
                      sku
                      monto
                      vendedor_codigo
                    }
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresProductos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentasVendedoresProductosExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVentasVendedoresProductos(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVentasVendedoresProductos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVendedoresFamiliaDocumento(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaDocumento(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    familia_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    nombrecomuna
                    codsuclegacy
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaDocumento;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVendedoresFamiliaDocumentoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaDocumento(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaDocumento;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVendedoresFamiliaFamilia(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaFamilia(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    familia_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    nombrecomuna
                    codsuclegacy
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaFamilia;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVendedoresFamiliaFamiliaExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaFamilia(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaFamilia;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVendedoresFamiliaProducto(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rut_empresa
                    sucursal_codigo
                    codigo
                    nombre
                    cliente_proveedor_rut
                    cliente_proveedor_nombre
                    direccion_codigo
                    direccion_nombre
                    familia_nombre
                    producto_codigo
                    sku
                    producto_nombre
                    tipo_dte_codigo
                    tipo_dte_nombre
                    folio
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    nombrecomuna
                    codsuclegacy
                    fecha_emision
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaProducto;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVendedoresFamiliaProductoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: vendedorInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            vendedor {
              obtenerReporteVendedoresFamiliaProducto(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.vendedor.obtenerReporteVendedoresFamiliaProducto;
            callback({ mensajes, respuesta });
        });
    }
}
VendedorService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function VendedorService_Factory() { return new VendedorService(i0.ɵɵinject(i1.GraphQLClient)); }, token: VendedorService, providedIn: "root" });
